import React, { useState, useEffect } from "react";
// import Alert from "../../components/Alert";
import Breadcrumb from "../../parts/Breadcrumb";
import ListSection from "../../components/ListSection";
import labels from "../../constants/LoginLogs";
import configuration from "../../config";
import { toast } from "react-toastify";
import { getAccessRights } from "../../utils/common";
import { useHistory } from "react-router-dom";
import Loader from "../../components/Loader/Loader";

// List all logs
function View() {
  const [isLoader, setIsLoader] = useState(false);
  const columns = [
    {
      title: "ID",
      field: "loginlog_id",
    },
    { title: "Name", field: "name" },
    { title: "Email", field: "email" },
    /* { title: "Role", field: "role" }, */
    { title: "Login", field: "login_date" },
    { title: "Logout", field: "logout_date" },
    { title: "IP", field: "ip" },
    /* { title: "Device", field: "device" }, */
  ];

  const btnGroups = [];
  const [data, setData] = useState([]);
  const history = useHistory();

  useEffect(() => {
    getAccessRights().then((rights) => {
      const rightsData = rights?.find((ac) => ac.code === "LOG_HISTORY");
      if (rightsData?.view === false) {
        history.push("/dashboard");
      }
    });
    setIsLoader(true);
    configuration
      .getAPI({ url: "common/list-login-logs", params: {} })
      .then((data) => {
        setIsLoader(false);
        if (data.status === 200) {
          setData(data.payload);
        }
      })
      .catch((error) => {
        setIsLoader(false);
        return toast.error(error.message);
      });
  }, []);

  return (
    <>
      {isLoader ? <Loader /> : ""}
      <Breadcrumb module={labels.loginLogs} />
      <ListSection
        captionTitle="View Login Log"
        columns={columns}
        data={data}
        disabledCheckbox={true}
        btnGroups={btnGroups}
      />
    </>
  );
}

export default View;
